const revocationRequest = document.getElementById(
  'request_type_Revocation of consent',
) as HTMLInputElement;
const deletionRequest = document.getElementById(
  'request_type_Deletion of personal data',
) as HTMLInputElement;

const handleRevocationRequestChange = () => {
  if (revocationRequest) {
    const div = document.getElementById('revocation-request-type');

    if (!div) {
      console.error('Missing element');
      return;
    }

    // maybe we are displaying a form which failed validation
    if (revocationRequest.checked) {
      div.classList.remove('d-none');
    }

    revocationRequest.addEventListener('change', (event) => {
      if ((<HTMLInputElement>event.currentTarget).checked) {
        div.classList.remove('d-none');
      } else {
        div.classList.add('d-none');
      }
    });
  }
};

const handleDeletionRequestChange = () => {
  if (deletionRequest) {
    const div = document.getElementById('deletion-request-type');

    if (!div) {
      console.error('Missing element');
      return;
    }

    // maybe we are displaying a form which failed validation
    if (deletionRequest.checked) {
      div.classList.remove('d-none');
    }

    deletionRequest.addEventListener('change', (event) => {
      if ((<HTMLInputElement>event.currentTarget).checked) {
        div.classList.remove('d-none');
      } else {
        div.classList.add('d-none');
      }
    });
  }
};

handleRevocationRequestChange();
handleDeletionRequestChange();
